import React, { useMemo } from 'react';
import styles from './O_CapsulePostHeaderMobile.module.css';
import A_CircleButton from '@/components/A_Atoms/A_CircleButton/A_CircleButton';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import Q_BlurEffect from '@/components/Q_Quarks/Q_BlurEffect/Q_BlurEffect';
import M_SelectPicker from '@/components/M_Molecules/M_SelectPicker/M_SelectPicker';
import {
  CapsuleViewMode,
  getCapsuleViewOptions,
} from '@/components/capsule-view/constants';
import { useTranslation } from '@/hooks/useTranslation';

interface O_CapsulePostHeaderMobileProps {
  onOpenPostMenu?: () => void;
  selectedView?: CapsuleViewMode;
  onViewSelect?: (view: CapsuleViewMode) => void;
  showActionsMenu?: boolean;
  onDelete?: () => void;
  capsuleId?: string;
}

export default function O_CapsulePostHeaderMobile({
  onOpenPostMenu,
  selectedView,
  onViewSelect,
}: O_CapsulePostHeaderMobileProps) {
  const t = useTranslation();

  const viewOptions = useMemo(() => getCapsuleViewOptions(t), [t]);
  const selectedOptionLabel = useMemo(
    () =>
      selectedView
        ? viewOptions.find(({ key }) => key === selectedView)?.label ||
          viewOptions[0]?.label ||
          ''
        : '',
    [selectedView, viewOptions]
  );

  const handleViewSelect = (option: string) => {
    const nextView = viewOptions.find(({ label }) => label === option)?.key;
    if (nextView && onViewSelect) {
      onViewSelect(nextView);
    }
  };

  return (
    <div className={styles.wrapper}>
      <Q_BlurEffect yAxis='top' />
      <A_CircleButton
        icon={
          <Q_Icon.ArrowLeftIcon
            width={8}
            height={16}
            fill='none'
            stroke='currentColor'
          />
        }
        variant='secondary'
        size='small'
        onClick={() => {
          window.history.back();
        }}
      />
      <div className={styles.text_wrapper}>
        {selectedView && onViewSelect && (
          <div className={styles.view_switcher}>
            <M_SelectPicker
              options={viewOptions.map(({ label }) => label)}
              selectedOption={selectedOptionLabel}
              onSelect={handleViewSelect}
              background='white'
            />
          </div>
        )}
      </div>
      <A_CircleButton
        icon={<Q_Icon.InfoIcon width={3} height={14} fill='none' />}
        variant='secondary'
        size='small'
        onClick={() => onOpenPostMenu?.()}
      />
    </div>
  );
}
